<template>
  <div>
    <h1>Accesos para Portal de Concesionarios</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar administrador concesionario"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
      <b-modal ref="my-modal" hide-footer title="Restablecer contraseña">
        <div class="d-block text-center">
          <h3>¿Estás seguro(a) que deseas restablecer contraseña de {{ user.email }}?</h3>
          <template v-if="user.confirmed === true">
            <b-button class="mt-2" variant="outline-warning" block @click="resetPassword(user)" v-if="this.clicked === 0">Aceptar</b-button>
            <b-button class="mt-2" variant="outline-gray" block  v-else-if="this.clicked === 1">Cargando...</b-button>
            <b-button class="mt-2" variant="outline-success" block  v-else-if="this.clicked === 2">Correo de Verificación Enviado</b-button>
            <b-button class="mt-2" variant="outline-danger" block  v-else-if="this.clicked === 3">Ha ocurrido un error</b-button>
          </template>
          <b-button class="mt-2" variant="outline-danger" block  v-else-if="user.confirmed === false">No se ha cambiado la contraseña temporal</b-button>
        </div>
      </b-modal>
      <b-modal ref="email-modal" hide-footer title="Cambiar E-mail">
        <div class="d-block text-center">
          <h3>¿Estás seguro(a) que deseas cambiar el email de {{ user.email  }}?</h3>
          <a-input
            placeholder="Correo electrónico"
            v-model="$v.newEmail.$model"
          />
          <b-button class="mt-2" variant="outline-warning" block @click="changeEmail(user)" v-if="this.clicked === 0">Aceptar</b-button>
          <b-button class="mt-2" variant="outline-gray" block  v-else-if="this.clicked === 1">Cargando...</b-button>
          <b-button class="mt-2" variant="outline-success" block  v-else-if="this.clicked === 2">Correo cambiado con exito</b-button>
          <b-button class="mt-2" variant="outline-danger" block  v-else-if="this.clicked === 3">Ha ocurrido un error</b-button>
        </div>
      </b-modal>
      <b-table
          show-empty
          stacked="md"
          :items="getConcesionarioUsers"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          empty-text="No existen registros por mostrar"
          emptyFilteredText="No existen registros por mostrar"
        >
          <template v-slot:cell(actions)="row">
            <b-button class="btn-sm" variant="outline-warning" @click="showModal(row.item)">Restablecer contraseña</b-button>
            <router-link size="btn-sm" :to="{name:'updateEmailPortalUsers', params: row.item}" class="mr-1">
              <b-button class="btn-sm" variant="outline-info">Editar</b-button>
            </router-link>
            <template v-if="row.item.confirmed === false">
              <b-button class="btn-sm" variant="outline-success" @click="resendEmail(row.item)" v-if="secondsPass === 0">Reenviar correo de bienvenida</b-button>
              <b-button class="btn-sm" variant="outline-success" v-else-if="secondsPass === 1">Espera para poder reenviar otro correo</b-button>
              <b-button class="btn-sm" variant="outline-success" v-else-if="secondsPass === 2">Ya se confirmo este correo previamente</b-button>
            </template>
          </template>
          <template v-slot:cell(concesionarioId)="row">
            {{ getConcesionarios[row.item.concesionarioId].name }}
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
    </b-row>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { notification } from 'ant-design-vue'
// import { encrypt } from '@/config/headers'
import { required, helpers } from 'vuelidate/lib/validators'
import headers from '@/config/headers.js'
const email = helpers.regex('email', /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/)
const GET_CONCESIONARIO_USERS = gql`
  query getConcesionarioUsers{
    getConcesionarioUsers{
      id
      email
      active
      concesionarioId
      cognitoUsername
      createdAt
      updatedAt
    }
  }
`
const GET_CONCESIONARIOS = gql`
  query getConcesionarios{
    getConcesionarios{
      id
      name
      email
    }
  }
`
const GET_USER_PORTAL_INFO = gql`
  query getUserPortalInfo($email: String){
    getUserPortalInfo(email: $email){
      userStatus
    }
  }
`
const RESET_CONCESIONARIO_MUTATION = gql`
  mutation resetUserConcesionarioPassword($username: String) {
    resetUserConcesionarioPassword(username: $username){
      message
    }
  }
`
const UPDATE_EMAIL_USER_PORTAL = gql`
  mutation updateEmailUserPortal($id: Int, $email: String) {
    updateEmailUserPortal(id: $id, email: $email){
      id
      concesionarioId
      email
    }
  }
`
const RESEND_EMAIL = gql`
  mutation resendPasswordPortal($email: String) {
    resendPasswordPortal(email: $email){
      success
    }
  }
`
export default {
  data() {
    return {
      fields: [
        // { key: 'id', label: 'Id' },
        { key: 'concesionario.name', label: 'Concesionario' },
        { key: 'email', label: 'Correo electrónico' },
        { key: 'createdAt', label: 'Fecha de creación' },
        { key: 'actions', label: 'Acciones' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      getConcesionarioUsers: [],
      getConcesionarios: [],
      user: {},
      clicked: 0,
      secondsPass: 0,
    }
  },
  apollo: {
    getConcesionarios: {
      query: GET_CONCESIONARIOS,
      context: headers(),
      result({ data }) {
        this.getConcesionarios = this.getConcesionarios.reduce((map, item) => {
          map[item.id] = item
          return map
        }, {})
        this.$apollo.query({ query: GET_CONCESIONARIO_USERS, context: headers() })
          .then(({ data }) => {
            // console.log(this.getConcesionarios)
            this.getConcesionarioUsers = data.getConcesionarioUsers
            this.getConcesionarioUsers.forEach(user => {
              this.getConsesionaryStatus(user, 'query')
              user.concesionario = this.getConcesionarios[user.concesionarioId]
            })
            // console.log(this.getConcesionarioUsers)
            this.totalRows = this.getConcesionarioUsers.length
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
  },
  validations: {
    newEmail: { required, email },
  },
  methods: {
    validateRegisteredEmail(email) {
      if (this.getConcesionarios[email.trim()]) {
        return false
      } else {
        return true
      }
    },
    closeEmailModal() {
      this.$refs['email-modal'].hide()
    },
    showEmailModal(user) {
      this.$refs['email-modal'].show()
      this.user = user
      this.newEmail = user.email
      this.clicked = 0
    },
    closeModal() {
      this.$refs['my-modal'].hide()
    },
    showModal(user) {
      this.$refs['my-modal'].show()
      this.user = user
      this.clicked = 0
    },
    getConsesionaryStatus(consen, called) {
      // console.log(driver)
      this.$apollo.query({ query: GET_USER_PORTAL_INFO, context: headers(), variables: { email: consen.email } })
        .then(({ data }) => {
          // console.log(data, 'conf')
          const driverinuse = (element) => element.email === consen.email
          if (called === 'modal') {
            if (data.getUserPortalInfo !== null) {
              if (data.getUserPortalInfo.userStatus === 'FORCE_CHANGE_PASSWORD') {
                this.modalError = false
              } else {
                this.modalError = true
              }
            } else {
              this.modalError = true
            }
          } else if (called === 'resendEmail') {
            if (data.getUserPortalInfo !== null) {
              if (data.getUserPortalInfo.userStatus === 'FORCE_CHANGE_PASSWORD') {
                this.$apollo.mutate({
                  mutation: RESEND_EMAIL,
                  context: headers(),
                  variables: { email: consen.email },
                })
                  .then(() => {
                    // console.log(data)
                    // this.clicked = 2
                    // this.closeModal()
                    notification.success({
                      message: '',
                      description: 'Se reenvio el email de bienvenida',
                    })
                    setTimeout(this.secondsPass = 0, 8000)
                  })
                  .catch(error => {
                    setTimeout(this.secondsPass = 2, 8000)
                    setTimeout(this.secondsPass = 0, 8000)
                    console.log(error)
                  })
              } else {
                this.getConcesionarioUsers[this.getConcesionarioUsers.findIndex(driverinuse)].confirmed = true
                setTimeout(this.secondsPass = 0, 8000)
              }
            } else {
              this.getConcesionarioUsers[this.getConcesionarioUsers.findIndex(driverinuse)].confirmed = true
              setTimeout(this.secondsPass = 0, 8000)
            }
          } else {
            if (data.getUserPortalInfo !== null) {
              if (data.getUserPortalInfo.userStatus === 'FORCE_CHANGE_PASSWORD') {
                this.getConcesionarioUsers[this.getConcesionarioUsers.findIndex(driverinuse)].confirmed = false
              } else {
                this.getConcesionarioUsers[this.getConcesionarioUsers.findIndex(driverinuse)].confirmed = true
              }
            } else {
              this.getConcesionarioUsers[this.getConcesionarioUsers.findIndex(driverinuse)].confirmed = true
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetPassword(user) {
      // this.clicked = true
      this.clicked = 1
      this.$apollo.mutate({
        mutation: RESET_CONCESIONARIO_MUTATION,
        context: headers(),
        variables: { username: user.email },
      })
        .then(() => {
          // console.log(data)
          this.clicked = 2
          this.closeModal()
          notification.success({
            message: '',
            description: 'Se restableció la contraseña del usuario ' + user.email,
          })
        })
        .catch(error => {
          this.clicked = 3
          console.log(error)
        })
    },
    changeEmail(user) {
      // this.clicked = true
      this.clicked = 1
      console.log(user)
      this.$apollo.mutate({
        mutation: UPDATE_EMAIL_USER_PORTAL,
        context: headers(),
        variables: { id: parseInt(user.id), email: this.newEmail },
      })
        .then(() => {
          // console.log(data)
          this.clicked = 2
          this.closeModal()
          notification.success({
            message: '',
            description: 'Se cambio el email del usuario',
          })
        })
        .catch(error => {
          this.clicked = 3
          console.log(error)
        })
    },
    resendEmail(user) {
      // this.clicked = true
      // this.clicked = 1
      this.secondsPass = 1
      this.getConsesionaryStatus(user, 'resendEmail')
      console.log(user)
      // this.$apollo.mutate({
      //   mutation: RESEND_EMAIL,
      //   context: headers(),
      //   variables: { email: user.email },
      // })
      //   .then(() => {
      //     // console.log(data)
      //     // this.clicked = 2
      //     // this.closeModal()
      //     notification.success({
      //       message: '',
      //       description: 'Se reenvio el email de bienvenida',
      //     })
      //     setTimeout(this.secondsPass = 0, 8000)
      //   })
      //   .catch(error => {
      //     this.clicked = 3
      //     console.log(error)
      //   })
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
<style scoped>

</style>
